import videojs from "video.js";
import playIcon from "../../../assets/images/player/play.svg";
import pauseIcon from "../../../assets/images/player/pause.svg";

class PlayPauseOverlay extends videojs.getComponent('Component') {
    constructor(player, options) {
        super(player, options);
        this.addClass('vjs-play-pause-overlay');
        this.updateIcon(); // Initial icon based on player state

        // Listen for play and pause events to toggle the icon
        player.on('play', () => this.updateIcon());
        player.on('pause', () => this.updateIcon());

        // Add click listener to toggle play/pause
        this.on('click', () => {
            if (player.paused()) {
                player.play();
            } else {
                player.pause();
            }
        });
    }

    updateIcon() {
        if (this.player().paused()) {
            this.el().innerHTML = `<img src="${playIcon}" />`;
        } else {
            this.el().innerHTML = `<img src="${pauseIcon}" />`; 
        }
    }

    createEl() {
        return videojs.dom.createEl('div', {
            className: 'vjs-play-pause-overlay custom-control'
        });
    }
}

videojs.registerComponent('PlayPauseOverlay', PlayPauseOverlay);